module.exports = __webpack_public_path__ + "static/media/mobile-google-play-store.c1595540.svg";